<div class="row" [ngClass]="{ 'mt-4 mb-4': mappedData && mappedData.length > 0 }">
  <div *ngFor="let data of mappedData; last as isLast" class="col-6 col-md-4 col-lg-3 mb-2">
    <div class="card product-card">
      <div class="card-body text-center">
        <div class="image-wrapper" routerLink="/product/{{ data.product.id }}">
          <img
            class="img-fluid"
            src="https://cdn1.gung.io/fit-in/250x250/filters:fill(white):background_color(white):etag({{
              data.product.extra.images[0].s3ETag
            }}):format(jpeg)/{{ data.product.extra.images[0].s3Uri }}"
            alt=""
          />
        </div>
        <div class="product-text">
          <lib-availability [availability]="data.availability"></lib-availability>
          <div class="text-truncate" translate>{{ data.product.name }}</div>
          <small
            >{{ 'ITEM_NO' | translate }}: <span translate>{{ data.product.id }}</span></small
          >
          <colmec-product-symbols [product]="data.product"></colmec-product-symbols>
          <div translate *ngIf="data.price" [class.d-none]="hidePrice">
            <div *ngIf="data.price.customerGrossPrice.value != data.price.customerNetPrice.value">
              <div style="padding-top: 2px" translate>GROSS_PRICE</div>
              <div>
                {{ data.price.customerGrossPrice.value | gungCurrency: data.price.customerGrossPrice.currencyCode }}
              </div>

              <div style="padding-top: 2px" translate>DISCOUNT</div>
              <div *ngIf="data.price.customerDiscountPercent !== 0">(-{{ data.price.customerDiscountPercent }}%)</div>
            </div>

            <div style="padding-top: 2px" translate>NET_PRICE</div>
            <div>{{ data.price.customerNetPrice.value | gungCurrency: data.price.customerNetPrice.currencyCode }}</div>
          </div>
        </div>
      </div>
      <button
        type="button"
        class="btn btn-sm btn-primary w-100 mt-1"
        [disabled]="selectedRim === data.product.id ? true : null"
        (click)="addRim(data.product.id, data.product.extra.parentProductId)"
        translate
      >
        {{ selectedRim === data.product.id ? 'ADDED_TO_BASKET' : 'ADD_TO_CART' }}
      </button>
    </div>
  </div>
</div>
